import { neighbours, nextOpen, type NavItem } from "./nav";

/**
 * Previous / Next along the navigator, in the same fixed order (nav.ts). When
 * the next step in line is already done, a second link jumps to the next step
 * that still needs something — the "continue" an advisor actually wants.
 * Quiet links, not buttons: each step keeps its Save as the one primary action.
 */
export function StepPager({
  flat,
  selectedId,
  onSelect,
  editable,
}: {
  flat: NavItem[];
  selectedId: string;
  onSelect: (item: NavItem) => void;
  editable: boolean;
}) {
  const { prev, next } = neighbours(flat, selectedId);
  const open = editable ? nextOpen(flat, selectedId) : null;
  const showOpen = open && next && open.id !== next.id;
  if (!prev && !next) return null;
  const label = (i: NavItem) => (i.subtitle && i.kind === "page" ? `${i.title} · ${i.subtitle}` : i.title);
  return (
    <nav className="adv-pager" aria-label="Previous and next step">
      <span>
        {prev && (
          <button type="button" className="link-action" onClick={() => onSelect(prev)}>
            ← {label(prev)}
          </button>
        )}
      </span>
      <span className="adv-pager-next">
        {showOpen && (
          <button type="button" className="link-action adv-pager-open" onClick={() => onSelect(open)}>
            Next open: {label(open)}
          </button>
        )}
        {next && (
          <button type="button" className="link-action" onClick={() => onSelect(next)}>
            {label(next)} →
          </button>
        )}
      </span>
    </nav>
  );
}
